import React from 'react';
import { useTranslation } from 'react-i18next';

// BARRE D'OUTILS CONTEXTUELLE (refonte visuelle 2026-09-25, polie 2026-09-26
// §5 : retour utilisateur "trois gros boutons d'application" — les pastilles
// pleines a icone/fond/bordure sont devenues trois libelles textuels, separes
// par un simple trait fin, actifs par un soulignement dore plutot qu'un
// remplissage. Meme principe qu'avant (cliquer sur ce dont on a besoin, le
// reste reste range), presentation plus editoriale, moins "boutons d'appli".
//
// DEUX onglets, desormais a l'INTERIEUR du panneau fixe de gauche
// (refonte 2026-10-11, artefact "Atelier Bookipix" : ".at-panel" >
// ".at-tabs" > ".at-pbody" — un panneau qui ne bouge plus, jamais de
// tiroir a ouvrir/fermer). Anciennement une barre d'outils separee dans
// l'en-tete, qui ouvrait/fermait un tiroir PAR-DESSUS ou A COTE du livre
// (AtelierDrawer) — ce tiroir disparait avec ce changement : il n'y a plus
// de notion de "ferme", un des deux onglets est TOUJOURS actif. `onToggle`
// est donc un simple selecteur ('photos'|'layout'), jamais un bascule vers
// null. "Pages" avait deja disparu d'ici le 2026-10-11 (plus tot le meme
// jour) : la pellicule de pages est TOUJOURS visible sous le livre.
function AtelierToolsBar({ activeDrawer, onToggle, photosCount, layoutLabel }) {
  const { t } = useTranslation('atelier');
  return (
    <div className="atelier-panel-tabs" role="tablist" aria-label={t('toolsBar.ariaLabel')}>
      <button
        type="button"
        role="tab"
        className="atelier-panel-tab"
        onClick={() => onToggle('photos')}
        aria-selected={activeDrawer === 'photos'}
      >
        {t('toolsBar.photos')}
        {photosCount > 0 && <small>{photosCount}</small>}
      </button>
      <button
        type="button"
        role="tab"
        className="atelier-panel-tab"
        onClick={() => onToggle('layout')}
        aria-selected={activeDrawer === 'layout'}
      >
        {layoutLabel || t('toolsBar.layout')}
      </button>
    </div>
  );
}

export default AtelierToolsBar;
